import { useSelector } from 'react-redux';
import { isEmpty } from 'ramda';

import { ListingLayout } from '../../components/ListingLayout';
import { RealtorCard } from '../../components/RealtorCard';
import { getRealtorsItems } from '../../selectors/listing';
import { CardAvatarContainer } from '../CardAvatarContainer';
import { EmptyListingStubContainer } from '../EmptyListingStubContainer';
import { useOpenCard } from '../../utils/openCard';
import { getSuperAgentBadge } from '../SuperAgentLevelViewContainer';

export function RealtorsListingContainer() {
  const realtorsItems = useSelector(getRealtorsItems);
  const onClick = useOpenCard();

  if (isEmpty(realtorsItems)) {
    return <EmptyListingStubContainer />;
  }

  return (
    <ListingLayout>
      {realtorsItems.map(
        ({
          cianUserId,
          age,
          agencyName,
          review,
          name,
          offersCount,
          rate,
          reviewsCount,
          userTrustLevelNumber,
          userTrustLevelName,
          hasRgrParticipation,
        }) => {
          return (
            <RealtorCard
              key={cianUserId}
              onClick={() => onClick(cianUserId)}
              previewImg={<CardAvatarContainer agentId={cianUserId} isCircleImage={true} />}
              agentId={cianUserId}
              age={age}
              agencyName={agencyName}
              hasRgrParticipation={hasRgrParticipation}
              review={review}
              name={name}
              offersCount={offersCount}
              rate={rate}
              reviewsCount={reviewsCount}
              superAgentBadge={getSuperAgentBadge(userTrustLevelNumber, userTrustLevelName)}
            />
          );
        },
      )}
    </ListingLayout>
  );
}
